export const REQUEST_DOCKET_PARTS = 'REQUEST_DOCKET_PARTS'
export const RECEIVE_DOCKET_PARTS = 'RECEIVE_DOCKET_PARTS'
export const REQUEST_RELATED_TRANSACTION_DATA = 'REQUEST_RELATED_TRANSACTION_DATA'
export const RECEIVE__RELATED_TRANSACTION_DATA = 'RECEIVE__RELATED_TRANSACTION_DATA'
export const SERVICE_ERROR = 'SERVICE_ERROR'
export const RESET_SERVICE_ERROR = 'RESET_SERVICE_ERROR'


// WEBPACK FOOTER //
// ./src/redux/actionTypes/relatedTransactionActionTypes.js